<template>
    <ac-modal title="Schedule Payment" ref="modalRef" :size-class="'modal-lg'" data-keyboard="false" data-backdrop="static">
        <template v-if="widgetReady">
            <div class="row">
                <div class="col-md-12">
                    <div class="alert alert-warning">
                        <input type="checkbox" class="filled-in" id='debt-ver-check' v-model="memberAgrees">
                        <label for="debt-ver-check" style="text-align: left">
                            {{ acknowledgement }} {{ new Date() | shortDate }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">                    
                    <div class="button-box">
                        <ac-button class="btn btn-sm btn-red" :action="closeModal">CANCEL</ac-button>
                        <ac-button class="btn btn-sm btn-green" :action="schedulePayment">SCHEDULE PAYMENT</ac-button>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
import { common } from "@/global/common";
import { api } from "@/global/framework/api"
import { notifications } from "@/global/notifications.js";
import moment from 'moment';
import AcButton from "../../global/customHtmlElements/AcButton.vue";

export default {
    name: "SchedulePaymentModal",
    components: { AcButton },
    data() {
        return {
            widgetReady: false,
            invoice: null,
            grandTotal: 0,
            company: null,
            memberAgrees: false,
        };
    },
    computed: {
        acknowledgement() {           
            return 'I agree, acknowledge and attest that I am providing authorization and consent to schedule a payment via ACH on ';
        }
    },
    methods: {
        async showModal(data) {      
            // console.log("showModal data: ", data);
            if (data.companyId != null && data.companyId != undefined){
                this.companyId = data.companyId;
                this.invoiceId = data.invoiceId;
                this.invoice = await api.getDataWithTwoIds('Invoice', this.invoiceId, 'GetInvoiceByIdForCompany', this.companyId);      
                this.grandTotal = this.invoice.lineItems.reduce((acc, item) => acc + item.amount, 0); 
            }     

            this.widgetReady = true;
            this.$refs.modalRef.open();
        },
        closeModal(status = false) {
            this.$refs.modalRef.close();
            this.$emit("modal-closed", status);
        },
        async schedulePayment() {
            if (this.memberAgrees) {
                let result = await api.post('Company', `${this.companyId}/ScheduleInvoicePaymentForCompany/${this.invoiceId}`);
                if (result) this.closeModal(true);
            }
            else {
                notifications.show({ title: "Failure!", message: "Must confirm member agrees to schedule payment." }, common.ACRESSA_NOTIFICATIONS.ERROR);
            }
        }
    },
}
</script>

<style scoped>
.modal-footer {
    padding-left: 0;
    padding-right: 0;
}
</style>